<template>
  <el-popover
    :append-to-body="true"
    v-model="isOpen"
    trigger="manual"
    :visible-arrow="false"
    popper-class="no-close-popover"
  >
    <div class="dropdown-content">
      <div
        v-for="option in options"
        :key="option.value"
        class="dropdown-item"
        :class="{ selected: isOptionSelected(option.value) }"
        @click.stop="toggleOption(option.value)"
      >
        <span class="option-text">{{ option.label }}</span>
        <i
          v-if="isOptionSelected(option.value)"
          class="el-icon-check check-icon"
        ></i>
      </div>

      <div class="dropdown-actions">
        <el-button class="cancel-btn" size="mini" @click.stop="cancel"
          >取消</el-button
        >
        <el-button size="mini" type="primary" @click.stop="confirm"
          >确认</el-button
        >
      </div>
    </div>
    <span
      class="dropdown-trigger"
      slot="reference"
      @click.stop="handleTriggerClick"
      >{{ triggerText }}</span
    >
  </el-popover>
</template>

<script>
import { deepClone } from "@/api/portrait.js";

export default {
  name: "CustomDropdown",
  props: {
    triggerText: {
      type: String,
      default: "人工反馈",
    },
    options: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isOpen: false,
      dropdownStyle: {},
      localSelectedValues: [],
    };
  },
  methods: {
    handleTriggerClick() {
      this.isOpen = !this.isOpen;
    },
    toggleOption(optionValue) {
      const index = this.localSelectedValues.indexOf(optionValue);
      if (index > -1) {
        this.localSelectedValues.splice(index, 1);
      } else {
        this.localSelectedValues.push(optionValue);
      }
    },

    isOptionSelected(optionValue) {
      return this.localSelectedValues.includes(optionValue);
    },

    cancel() {
      this.localSelectedValues =
        deepClone(this.item?.suspectInfo?.suspectType) || [];
      this.isOpen = false;
    },

    confirm() {
      if (this.localSelectedValues.length === 0) {
        this.$message.error("请选择");
        return;
      }

      this.$emit("confirm", this.localSelectedValues);
      this.isOpen = false;
    },
  },
  created() {
    this.localSelectedValues =
      deepClone(this.item?.suspectInfo?.suspectType) || [];
  },
  watch: {
    item: {
      handler(newVal) {
        this.localSelectedValues =
          deepClone(newVal?.suspectInfo?.suspectType) || [];
      },
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
.dropdown-content {
  // padding: 8px 0;
  // text-align: center;
}

.dropdown-item {
  padding: 8px 0px;
  text-align: left;
  color: #212121;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  &:hover {
    background-color: #f5f7fa;
  }

  &.selected {
    color: #4fa1a4;
  }

  .option-text {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .check-icon {
    color: #4fa1a4;
    width: 16px;
  }
}

.dropdown-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 12px;
  border-top: 1px solid #e4e7ed;
}
.dropdown-trigger {
  color: #212121;
  border-bottom: 1px solid #333;
  cursor: pointer;
}
.cancel-btn {
  color: #212121;
  border: 1px solid #d9d9d9;
}
</style>
